import { axios, Response } from '../index'

type Body = {
  taskId: string
  fileName: string
  fileContentType: string

  originalFileName: string
  size: number
  folderId: string
}

const addFileToTask = (
  companyId: string,
  personaType: string,
  personaId: string,
  body: Body
): Response<null> => {
  return axios.post('/v1/tasks/files', body, {
    'X-CompanyID': companyId,
    'X-PersonaType': personaType,
    'X-PersonaID': personaId
  })
}

export default addFileToTask
